// file-upload.service.ts
import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';

export interface UploadedFileInfo {
  fileUrl: string; // public URL
  fileKey: string;
}

@Injectable({ providedIn: 'root' })
export class FileUploadService {
  private httpNoInterceptor: HttpClient;

  constructor(
    @Inject('environment') private environment: any,
    private http: HttpClient,
    handler: HttpBackend
  ) {
    // httpNoInterceptor will NOT use interceptors
    this.httpNoInterceptor = new HttpClient(handler);
  }

  uploadFileToS3(
    file: Blob | File,
    fileName: string,
    documentType: string,
    orderId: string
  ): Observable<UploadedFileInfo> {
    const contentType =
      (file as File).type && (file as File).type.trim() !== ''
        ? (file as File).type
        : 'application/octet-stream';

    const baseUrlV2 = `${this.environment.apiUrl}documents/upload-url`;

    return this.http
      .post(baseUrlV2, {
        fileName,
        contentType,
        documentType,
        orderId,
      })
      .pipe(
        switchMap((res: any) => {
          const { uploadUrl, fileKey } = res.data;

          const headers = new HttpHeaders({
            'Content-Type': contentType,
          });

          // Use httpNoInterceptor so Authorization is NOT added
          return this.httpNoInterceptor
            .put(uploadUrl, file, {
              headers,
              responseType: 'text',
            })
            .pipe(
              map(() => ({
                fileUrl: `${this.environment.s3UrlDownload}${fileKey}`,
                fileKey,
              }))
            );
        })
      );
  }
}
